import { useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchLatestForUser } from '../../models/timeclock/entry/entry';

import type { User } from '../../models/user/_types';

export const useTimeClockPage = (user: User) => {
  const queryClient = useQueryClient();

  const onClose = () => {
    queryClient.invalidateQueries({ queryKey: ['entries'] });
  };

  const { data: logEntry, isLoading: logEntryLoading } = useQuery({
    queryKey: ['entries', user],

    queryFn: () => {
      return fetchLatestForUser(user);
    },
  });

  return {
    onClose,
    logEntry,
    logEntryLoading,
  };
};
